import timezones, { TimeZone } from 'timezones-list';

export const expandedTimezoneList: TimeZone[] = [
    ...timezones,
    {
        label: 'Asia/Saigon (GMT+07:00)',
        tzCode: 'Asia/Saigon',
        name: '(GMT+07:00) Ho Chi Minh City, Da Nang, Biên Hòa, Nha Trang, Cần Thơ',
        utc: '+07:00',
    },
    {
        label: 'Pacific/Johnston (GMT-10:00)',
        tzCode: 'Pacific/Johnston',
        name: '(GMT-10:00) Johnston Atoll',
        utc: '-10:00',
    },
    {
        label: 'Asia/Rangoon (GMT+06:30)',
        tzCode: 'Asia/Rangoon',
        name: '(GMT+06:30) Yangon, Mandalay, Nay Pyi Taw, Mawlamyine, Kyain Seikgyi Township',
        utc: '+06:30',
    },
    {
        label: 'Europe/Kiev (GMT+02:00)',
        tzCode: 'Europe/Kiev',
        name: '(GMT+02:00) Kyiv, Kharkiv, Donetsk, Odesa, Dnipro',
        utc: '+02:00',
    },
    {
        label: 'Pacific/Ponape (GMT+11:00)',
        tzCode: 'Pacific/Ponape',
        name: '(GMT+11:00) Kolonia, Kolonia Town, Palikir - National Government Center',
        utc: '+11:00',
    },
    {
        label: 'Pacific/Truk (GMT+10:00)',
        tzCode: 'Pacific/Truk',
        name: '(GMT+10:00) Weno, Colonia',
        utc: '+10:00',
    },
];
